/* eslint-disable react/jsx-curly-newline */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { CommonDropdown, RegularButton, CommonInput, ICommonDropdownOption, Loader } from 'pg-ui-library';
import { useFormik } from 'formik';
import * as yup from 'yup';
import { useNavigate } from 'react-router-dom';
import ExpenseService from 'src/services/expense.service';
import { ExpenseListResponse } from 'src/interfaces/expense';
import { useQuery } from '@tanstack/react-query';
import { DataGrid, GridColDef } from '@mui/x-data-grid';
import { Chip } from '@mui/material';
import { Container, ScreenHeader, RightHeader, PageTitle, EmptyContainer } from './createStyles';
import { CellSpan } from './styles';
import { ExpenseStatus } from './enums/expense-status';
import { useTranslation } from 'react-i18next';
import { DateTime } from 'luxon';
import { NewFiltersExpense } from './modals/filtersModal';
import DownloadExpenseModal from './modals/downloadExpenseModal';
import { currencySymbol } from 'src/utils/currency';

const myexpenseOptions: ICommonDropdownOption[] = [
  // {
  //   key: '1',
  //   label: ExpenseStatus.ALL.label,
  //   value: ExpenseStatus.ALL.value,
  // },
  {
    key: '1',
    label: ExpenseStatus.DRAFT.label,
    value: ExpenseStatus.DRAFT.value,
  },
  {
    key: '2',
    label: ExpenseStatus.SUBMITTED.label,
    value: ExpenseStatus.SUBMITTED.value,
  },
  {
    key: '3',
    label: ExpenseStatus.APPROVED.label,
    value: ExpenseStatus.APPROVED.value,
  },
  {
    key: '4',
    label: ExpenseStatus.COMPLETED.label,
    value: ExpenseStatus.COMPLETED.value,
  },
  {
    key: '5',
    label: ExpenseStatus.REJECTED.label,
    value: ExpenseStatus.REJECTED.value,
  },
  {
    key: '6',
    label: ExpenseStatus.BILL_PROCESSED.label,
    value: ExpenseStatus.BILL_PROCESSED.value,
  },
  {
    key: '7',
    label: ExpenseStatus.PAY_PROCESSED.label,
    value: ExpenseStatus.PAY_PROCESSED.value,
  },
];

const ExpenseList: React.FC = () => {
  const navigate = useNavigate();
  const validationSchema = yup.object({
    subject: yup.string().max(255).required(),
  });

  const { t } = useTranslation();
  const statusMapping: Record<
    string,
    { color: 'default' | 'primary' | 'secondary' | 'error' | 'success'; label: string; bgColor: string }
  > = {
    rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Rejected: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },
    Reject: { color: 'default', label: 'Rejected', bgColor: '#d32f2f' },

    draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },
    Draft: { color: 'default', label: 'Draft', bgColor: '#546E7A' },

    submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },
    Submitted: { color: 'default', label: 'Submitted', bgColor: '#0288d1' },

    approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    Approved: { color: 'default', label: 'Approved', bgColor: '#F9A825' },
    'On Hold': { color: 'default', label: 'Approved', bgColor: '#F9A825' },

    bill_processed: { color: 'default', label: 'Bill Processed', bgColor: '#7b1fa2' }, // purple
    Bill_processed: { color: 'default', label: 'Bill Processed', bgColor: '#7b1fa2' },

    pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' }, // teal
    Pay_processed: { color: 'default', label: 'Pay Processed', bgColor: '#00897b' },

    completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    resolved: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
    Completed: { color: 'default', label: 'Completed', bgColor: '#388e3c' },
  };

  // const allStatusOptions: ICommonDropdownOption[] = Object.values(ExpenseStatus).map((status, index) => ({
  //   key: String(index),
  //   label: status.label,
  //   value: status.value === 'all' ? '' : status.value, // 👈 important
  // }));

  const allStatusOptions: ICommonDropdownOption[] = Object.values(ExpenseStatus).map((status, index) => ({
    key: String(index),
    label: status.label,
    value: status.value,
  }));

  const viewExpense = (row: any) => {
    navigate(`${row.id}`);
  };

  const expenseColumns: GridColDef[] = [
    {
      headerName: 'Expense ID',
      headerClassName: 'CommonHeaderClass',
      field: 'expenseShowId',
      minWidth: 120,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents" onClick={() => viewExpense(params.row)}>
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Worker',
      headerClassName: 'CommonHeaderClass',
      field: 'employeeName',
      minWidth: 120,
      sortable: true,
      filterable: false,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents">
          {params.value}
        </CellSpan>
      ),
    },
    {
      headerName: 'Period Ending',
      headerClassName: 'CommonHeaderClass',
      field: 'weekEnd',
      minWidth: 120,
      renderCell: params => (
        <CellSpan title={params.value} data-tag="allowRowEvents">
          {params.value}
        </CellSpan>
      ),
      sortable: true,
      filterable: true,
    },
    {
      headerName: 'Company',
      headerClassName: 'CommonHeaderClass',
      field: 'companyName',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Client',
      headerClassName: 'CommonHeaderClass',
      field: 'clientName',
      minWidth: 120,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Job Title',
      headerClassName: 'CommonHeaderClass',
      field: 'jobTitle',
      minWidth: 150,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Hire Type',
      headerClassName: 'CommonHeaderClass',
      field: 'hireType',
      minWidth: 100,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Items',
      headerClassName: 'CommonHeaderClass',
      field: 'totalReceipts',
      minWidth: 90,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Total Amount',
      headerClassName: 'CommonHeaderClass',
      field: 'totalAmount',
      minWidth: 120,
      sortable: true,
      filterable: false,
      renderCell: params => {
        const amount = params.value;
        const currency = params.row.currency;

        return (
          <CellSpan title={`${currencySymbol(currency)}${amount}`} data-tag="allowRowEvents">
            {currencySymbol(currency)}
            {amount.toFixed(2)}
          </CellSpan>
        );
      },
    },
    {
      headerName: 'Version',
      headerClassName: 'CommonHeaderClass',
      field: 'version',
      minWidth: 80,
      sortable: true,
      filterable: false,
    },
    {
      headerName: 'Status',
      field: 'status',
      width: 140,
      renderCell: params => {
        const status = params.value as string;
        const { label, bgColor } = statusMapping[status] || {
          color: 'default',
          label: 'Unknown',
          bgColor: '#9e9e9e',
        };
        return (
          <Chip
            label={label}
            variant="outlined"
            style={{
              backgroundColor: bgColor,
              fontSize: '12px',
              color: 'white',
              borderColor: 'transparent',
              textTransform: 'capitalize',
              borderRadius: '6px',
            }}
          />
        );
      },
    },
  ];

  const formik = useFormik({
    initialValues: {
      moduleCategory: '',
      subCatergory: '',
      subject: '',
      description: '',
      priority: '',
      attachments: '',
      searchQuery: '',
      expenseCategory: '',
    },
    validationSchema,
    onSubmit: async (values: any) => {
      try {
        console.log('Form Submitted:', values);
      } catch (error) {
        console.error('Error during form submission', error);
      }
    },
  });

  const CreateExpense = () => {
    navigate('/expenses/create');
  };

  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [sortBy, setSortBy] = useState('');
  const [searchTerm, setsearchTerm] = useState('');
  const [sortDirection, setSortDirection] = useState('');
  const [status, setStatus] = useState('');
  const companyId = '';

  const [downloadOpen, setDownloadOpen] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);

  const [newFilterIsOpen, setNewFilterIsOpen] = useState(false);

  const [filters, setFilters] = useState({
    fromDate: null as Date | null,
    toDate: null as Date | null,
    status: '',
    hireType: '',
    expenseShowId: '',
    clientName: '',
    employeeName: '',
    companyName: '',
    dateCriteria: '',
    dateFilterType: '',
    assignmentId: '',
    accountingId: '',
  });

  const {
    isLoading,
    isFetching,
    data: expenseData,
  } = useQuery<{
    items: ExpenseListResponse[];
    meta: {
      page: number;
      limit: number;
      total: number;
      totalPages: number;
    };
  }>(
    ['expense-list', page, limit, searchTerm, sortBy, sortDirection, JSON.stringify(filters)],
    async () => {
      return ExpenseService.getExpenseList({
        page,
        limit,
        search: searchTerm,
        sortBy,
        sortDirection,
        status: filters.status,
        hireType: filters.hireType,
        expenseShowId: filters.expenseShowId,
        assignmentId: filters.assignmentId,
        accountingId: filters.accountingId,
        clientName: filters.clientName,
        employeeName: filters.employeeName,
        dateCriteria: filters.dateCriteria,
        dateFilterType: filters.dateFilterType,
        fromDate: apiFromDate,
        toDate: apiToDate,
        ...(filters.companyName ? { companyName: filters.companyName } : {}),
      });
    },
    {
      keepPreviousData: true,
    }
  );

  const updateFilters = (
    fromDate: Date | null,
    toDate: Date | null,
    selectedCompany: any,
    status: string,
    employmentType: string,
    expenseShowId: string,
    assignmentId: string,
    accountingId: string,
    employmentStatus: string,
    clientName: string,
    hireType: string,
    employeeName: string,
    dateCriteria: string,
    dateRangeType: string
  ) => {
    setPage(1);

    setFilters({
      fromDate,
      toDate,
      status,
      hireType,
      expenseShowId,
      assignmentId,
      accountingId,
      clientName,
      employeeName,
      companyName: selectedCompany || '',
      dateCriteria: dateCriteria || 'period',
      dateFilterType: dateRangeType,
    });
  };

  const formatDateForApi = (date: Date | null) => {
    if (!date) return undefined;
    return DateTime.fromJSDate(date).toFormat('yyyy-MM-dd');
  };

  const apiFromDate = formatDateForApi(filters.fromDate);
  const apiToDate = formatDateForApi(filters.toDate);

  useEffect(() => {}, [page, limit, searchTerm, status]);

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
  };

  const handlePerRowsChange = async (newLimit: number, newPage: number) => {
    setLimit(newLimit);
    setPage(newPage);
  };

  const onPageMetaChange = (model: any) => {
    setPage(model.page + 1);
    setLimit(model.pageSize);
  };

  const onSortMetaChange = async (changes: any) => {
    setSortBy(changes[0].field as unknown as string);
    setSortDirection(changes[0].sort);
  };

  const formattedData = expenseData?.items?.map(row => ({
    ...row,
  }));

  const handleDownload = async (type: 'excel' | 'csv' | 'pdf') => {
    setDownloadLoading(true);
    try {
      const url = ExpenseService.downloadExpense({
        type,
        search: searchTerm,
        sortBy,
        sortDirection,
        status: filters.status,
        hireType: filters.hireType,
        expenseShowId: filters.expenseShowId,
        assignmentId: filters.assignmentId,
        accountingId: filters.accountingId,
        clientName: filters.clientName,
        employeeName: filters.employeeName,
        dateCriteria: filters.dateCriteria,
        dateFilterType: filters.dateFilterType,
        fromDate: apiFromDate,
        toDate: apiToDate,
        ...(filters.companyName ? { companyName: filters.companyName } : {}),
      });

      const response = await fetch(url, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken') || ''}`,
        },
      });

      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();

      // Create a file name
      const fileExtension = type === 'pdf' ? 'zip' : type === 'csv' ? 'csv' : 'xlsx';
      const fileName = `Expenses_${new Date().toISOString().split('T')[0]}.${fileExtension}`;

      // Create a temporary link to trigger download
      const link = document.createElement('a');
      link.href = window.URL.createObjectURL(blob);
      link.download = fileName;
      link.click();
      window.URL.revokeObjectURL(link.href);

      setDownloadOpen(false);
    } catch (error) {
      console.error('Error downloading expenses:', error);
    } finally {
      setDownloadLoading(false);
    }
  };

  return (
    <Container>
      <NewFiltersExpense
        isOpen={newFilterIsOpen}
        setIsOpen={setNewFilterIsOpen}
        updateFilters={updateFilters}
        statusOptions={allStatusOptions}
      />

      <DownloadExpenseModal
        isOpen={downloadOpen}
        setIsOpen={setDownloadOpen}
        onDownload={handleDownload}
        loading={downloadLoading}
      />

      <ScreenHeader>
        <PageTitle>Expenses</PageTitle>

        <RightHeader style={{ display: 'flex', alignItems: 'center' }}>
          <RegularButton onClick={() => setNewFilterIsOpen(true)}>Filters</RegularButton>

          <RegularButton onClick={CreateExpense}>Create Expense</RegularButton>

          <RegularButton onClick={() => setDownloadOpen(true)}>Download Expense</RegularButton>
        </RightHeader>
      </ScreenHeader>

      {isLoading || isFetching ? (
        <EmptyContainer>
          <Loader />
        </EmptyContainer>
      ) : (
        <div>
          {formattedData && formattedData.length > 0 ? (
            <DataGrid
              rows={formattedData}
              columns={expenseColumns}
              pagination
              paginationMode="server"
              onPaginationModelChange={state => {
                onPageMetaChange(state);
              }}
              onSortModelChange={state => {
                onSortMetaChange(state);
              }}
              paginationModel={{
                page: page - 1,
                pageSize: limit,
              }}
              pageSizeOptions={[10, 20, 50]}
              rowCount={expenseData?.meta?.total || 0}
              loading={isLoading || isFetching}
              disableColumnFilter
              sx={{
                font: '14px Biotif',
                fontWeight: 'bold',
                '& .CommonHeaderClass': {
                  color: '#9399B2',
                  font: '16px Biotif',
                  fontWeight: 'bold',
                },
                minHeight: '150px',
                '& .MuiDataGrid-scrollbar--horizontal': {
                  zIndex: 0,
                },
              }}
            />
          ) : (
            <div style={{ minHeight: '100px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              No Expenses to display. If you need assistance, you can create a new Expense by clicking &quot;Create
              Expense.&quot;
            </div>
          )}
        </div>
      )}
    </Container>
  );
};

export default ExpenseList;
